import React from 'react';
import SideBar from '../../components/Sidebar';
import { useProps } from '../../hooks';

const MainLayout = ({ children, ...props }) => {
    //const dispatch = useDispatch();
    const addProps = useProps;

    return (
        <React.Fragment>
            <SideBar>
                {addProps(children, { ...props })}
            </SideBar>
        </React.Fragment>
    )
};

MainLayout.propTypes = {};

MainLayout.defaultProps = {};

export default MainLayout;
